import type Question from './Question'

export default class QuestionPathology implements Question {
  componentName = 'QuestionPathology'
  date: string
  pathology: string
  center: string

  constructor(data: Partial<QuestionPathology> = {}) {
    this.date = data?.date ?? ''
    this.pathology = data?.pathology ?? ''
    this.center = data?.center ?? ''
  }

  get deconstructedDate() {
    if (!this.date) {
      return { day: '01', month: '00', year: '0000' }
    }

    const [day, month, year] = this.date.split('/')
    return { day, month, year }
  }

  set month(month: string) {
    const { day, year } = this.deconstructedDate
    this.date = `${day}/${month}/${year}`
  }
  get month() {
    return this.deconstructedDate.month
  }

  set year(year: string) {
    const { day, month } = this.deconstructedDate
    this.date = `${day}/${month}/${year}`
  }
  get year() {
    return this.deconstructedDate.year
  }

  isEmpty() {
    return !this.date || !this.pathology || !this.center
  }

  reset() {
    this.pathology = ''
    this.center = ''
  }
}
